// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.AssertionPoPKey
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.crypto.EcPublicKey
import org.multipaz.cbor.Tstr

fun AssertionPoPKey.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "EzJD-VUSnoUldPO6YxI4HUwqZkfMV2UQoZrX8P8p8JU")
val AssertionPoPKey_cborSchemaId = ByteString(19, 50, 67, -7, 85, 18, -98, -123, 37, 116, -13, -70, 99, 18, 56, 29, 76, 42, 102, 71, -52, 87, 101, 16, -95, -102, -41, -16, -1, 41, -16, -107)

fun AssertionPoPKey.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PoPKey")
    builder.put("publicKey", this.publicKey.toDataItem())
    builder.put("targetUrl", Tstr(this.targetUrl))
    return builder.end().build()
}

fun AssertionPoPKey_fromDataItem(dataItem: DataItem): AssertionPoPKey {
    val publicKey = EcPublicKey.fromDataItem(dataItem["publicKey"])
    val targetUrl = dataItem["targetUrl"].asTstr
    return AssertionPoPKey(
        publicKey = publicKey,
        targetUrl = targetUrl,
    )
}
